import React from 'react';
import { Row, Col, Typography, Image, Divider } from 'antd';
import ResearchDomainsImage from '../../Assets/About/NCGSA-Research-Domains.png';

const { Title, Paragraph } = Typography;

const researchDomains = [
  'Geo Forensic, Geo Health and Geo Hazards',
  'Mineral Inventory',
  'Theoretical, Computational and Observational Astronomy & Astrophysics',
  'Space Education, Outreach and Capacity Building',
  'GNSS Research, Development and Applications',
  'Small Satellite Development',
  'Capacity Building in Space Sector',
  'Remote Sensing for Agriculture',
  'Geological Applications of GIS and Remote Sensing',
  'Water and Forest Resources',
  'Climate and Environment',
  'Land Use, Land Cover and Urban Planning',
];

const ResearchDomains = () => (
  <section className="research-domains-section">
    <Row gutter={[64, 40]} justify="space-between" align="middle">
      <Col xs={24} md={15}>
        <Title level={2} className="research-domains-title">Research Domains</Title>
        <Divider className="ncgsa-divider" />
        <Paragraph className="research-domains-paragraph">
          NCGSA Research Labs aims significant progress in the following research domains:
        </Paragraph>
        <ul className="research-domains-list">
          {researchDomains.map((domain) => <li key={domain}>{domain}</li>)}
        </ul>
      </Col>
      <Col xs={24} md={9}>
        <div className="research-domains-image-container">
          <Image src={ResearchDomainsImage} alt="NCGSA research domains represented around Earth" className="research-domains-image" preview={false} />
        </div>
      </Col>
    </Row>
  </section>
);

export default ResearchDomains;
